import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { isIOS, isAndroid } from 'react-device-detect';

import bibleLogoWhite from '../assets/images/bible-logo-white.svg'
import bibleLogoBlack from '../assets/images/bible-logo-black.svg'

class Home extends Component{
	_darkMode() {
		let d = document.getElementsByTagName("HTML")[0];

    if (d.classList.contains("dark-mode")) {
      d.classList.remove("dark-mode");
			localStorage.setItem("darkmode", "false");
			window.ReactNativeWebView && window.ReactNativeWebView.postMessage("day-mode");
    } else {
      d.classList.add("dark-mode");
			localStorage.setItem("darkmode", "true");
			window.ReactNativeWebView && window.ReactNativeWebView.postMessage("dark-mode");
    }
	}

	_renderLink() {
    if (isIOS) {
			return <a href="https://app.goodnightjournal.com/login" id="navigation_journal_from_ios">Journal</a>
    } else if (isAndroid) {
    	return <a href="https://app.goodnightjournal.com/login" id="navigation_journal_web_from_android">Journal</a>
		} else {
			return <a href="https://app.goodnightjournal.com/login" id="navigation_journal_web">Journal</a>
		}
	}

	render() {
		return(
			<nav className="main-nav">
				<div className="logo-nav">
					<Link to="/" id="navigation_happy_logo">
						<img src={bibleLogoWhite} className="logo logo-white" alt="Happy from Goodnight Jornal" />
						<img src={bibleLogoBlack} className="logo logo-black" alt="Happy from Goodnight Jornal" />
					</Link>
				</div>
				<div className="main-nav-menu">
					<ul className="non-member">
						<li><a href="https://happy.goodnightjournal.com/" id="navigation_happy_web">Happy</a></li>
						<li>{this._renderLink()}</li>
						<li><button className="link-btn" onClick={this._darkMode} id="navigation_darkmode"><ion-icon name="moon"></ion-icon></button></li>
					</ul>
				</div>
			</nav>
		)
	}
}

export default Home
